module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-114x114-fa5aec1d182ea21b39fbea698a8b0cd5.png";